// src/tenantAdmin/pages/CompanyDetailsPage.jsx
//
// The "Dati azienda" tab of Gestione Workspace: the invoicing record of the
// company the console's selector points at.
//
// ⛔ Reaching it already proves the guard chain: RequireWorkspaceAdmin (the
// console) then RequireCustomerAdmin (this tab), so the page itself may assume a
// company claim — but NEVER a specific company id. That comes from the layout's
// Outlet context (`useOutletContext().company.companyId`) and must still pass
// `isCustomerAdminOf` before any /admin/customers/{cid}* call — which is where
// `CompanyBillingBody` gates it. Aiming at a company the user does not administer
// would answer 403 CUSTOMER_ADMIN_REQUIRED and raise the global permissions-drift
// banner, telling the user their rights changed when WE picked the wrong company.
//
// ⛔ It renders the SAME body as /billing-details and deliberately not a redirect
// to it (nor the reverse): that page resolves the company from the ACTIVE
// workspace, this tab from the selector. Two questions, two answers, one body —
// see src/components/credits/CompanyBillingBody.jsx.
//
// ⛔ No `canEditCountry` here: it is a superadmin right, and a superadmin never
// reaches this console (RequireWorkspaceAdmin bounces them). The body reads the
// flag from the claims, so this page cannot grant it by accident.
import React from 'react';
import { useOutletContext } from 'react-router-dom';
import CompanyBillingBody from '../../components/credits/CompanyBillingBody.jsx';

export default function CompanyDetailsPage() {
  const { company } = useOutletContext();
  // Styled like its sibling tabs; the layout's <h1> titles the console, so the
  // body's card header is an <h2>.
  return <CompanyBillingBody customerId={company?.companyId || null} variant="tab" />;
}
